import {
  COOKIE_CONSENT_POLICY_VERSION,
  COOKIE_CONSENT_STORAGE_KEY,
} from '../constants/CookieConsent';

const defaultConsent = {
  necessary: true,
  functional: false,
  thirdParty: false,
  advertising: false,
  timestamp: null,
  version: null,
};

export function getStoredConsent() {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }

    return {
      ...defaultConsent,
      ...parsed,
      necessary: true,
    };
  } catch {
    return null;
  }
}

export function hasValidConsent() {
  const consent = getStoredConsent();
  return consent?.version === COOKIE_CONSENT_POLICY_VERSION && Boolean(consent?.timestamp);
}

export function hasFunctionalConsent() {
  const consent = getStoredConsent();
  return hasValidConsent() && consent.functional === true;
}

export function hasThirdPartyConsent() {
  const consent = getStoredConsent();
  return hasValidConsent() && consent.thirdParty === true;
}

export function hasAdvertisingConsent() {
  const consent = getStoredConsent();
  return hasValidConsent() && consent.advertising === true;
}

export function saveStoredConsent(preferences) {
  const consent = {
    necessary: true,
    functional: preferences.functional === true,
    thirdParty: preferences.thirdParty === true,
    advertising: preferences.advertising === true,
    timestamp: new Date().toISOString(),
    version: COOKIE_CONSENT_POLICY_VERSION,
  };

  localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(consent));
  return consent;
}

export function clearNonEssentialStorage() {
  if (typeof window === 'undefined') {
    return;
  }

  const keysToRemove = [];
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (!key) {
      continue;
    }

    if (
      key === 'preferred-language'
      || key.startsWith('billing-reminder-dismissed:')
      || key.startsWith('store-registration-')
      || key.startsWith('team-member-registration-')
      || key.includes('-registration-')
      || key.endsWith('-update-cache')
      || key.endsWith('-update-initial')
    ) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key));
}
